import type { TranslationInterface } from './translation.types';

export const trLocale: TranslationInterface = {
  'write-a-message': 'Bir mesaj yazın...',
  'session-closed-lead': 'Sorununuz çözüldü!',
  'new-conversation': 'Yeni konuşma',
  'welcome-title': 'Destek sohbetimize hoş geldiniz',
  'welcome-description':
    'Yardım etmek için buradayız! Bir konuşma başlatın, en kısa sürede size geri döneceğiz.',
  'your-name': 'Adınız',
  'your-email': 'E-posta adresiniz',
  'start-chat': 'Destekle konuş',
  'starting-chat': 'Bağlanıyor...',
  'i-need-more-help': 'Daha fazla yardıma ihtiyacım var',
  'this-was-helpful': 'Bu yardımcı oldu',
  optional: 'İsteğe bağlı',
  'no-conversations-yet': 'Henüz konuşma yok',
  'back-to-conversations': 'Konuşmalara geri dön',
  'closed-conversations': 'Kapatılan konuşmalar',
};
